import { useEffect } from "react";
import { ClientForm, TextInput, FormActions, Button } from "livemap-ui";
import { useForm } from "react-hook-form";
import { useAddToast } from "../contexts/toast";
import { useFocus } from "../hooks/focus";
import { FormProps } from "./FormProps";

export interface EmailFormData {
  email: string;
}

export interface EmailFormProps {
  isSending: boolean;
  submitText: string;
}

export interface EmailFormDispatch {
  onSubmit(form: EmailFormData): void;
}

type Props = EmailFormDispatch & EmailFormProps & FormProps;

export function EmailForm({
  isSending,
  onSubmit,
  submitText,
  isActive,
}: Props) {
  const addToast = useAddToast();
  const [focusRef, setInputFocus] = useFocus();
  const { register, handleSubmit, errors } = useForm<EmailFormData>({
    reValidateMode: "onSubmit",
  });

  useEffect(() => {
    if (errors.email) {
      addToast({
        id: "bad-verification-code",
        title: "Invalid E-mail",
        text: errors.email.message || "",
        type: "danger",
      });
    }
  }, [addToast, errors.email]);

  useEffect(() => {
    isActive && setInputFocus();
  }, [isActive, setInputFocus]);

  return (
    <ClientForm onSubmit={handleSubmit(onSubmit)}>
      <TextInput
        label="E-mail address"
        name="email"
        ref={(htmlRef) => {
          focusRef.current = htmlRef;
          register({
            required: "Please enter your e-mail address.",
            pattern: {
              value: /[^@]+@[^.]+\..+/i,
              message: "That e-mail address does not look valid.",
            },
          })(htmlRef);
        }}
      />

      <FormActions>
        <Button disabled={isSending}>{submitText}</Button>
      </FormActions>
    </ClientForm>
  );
}
